module.exports = __webpack_public_path__ + "static/media/01A.bd0d0142.png";